// extracted by mini-css-extract-plugin
export default {"desktop-only":"TestimonialsBox_desktop-only__vlMvk","mobile-only":"TestimonialsBox_mobile-only__DqIOd"};